export default null;

export const DEFAULT_PAGE_SIZE = 12;

export const HISTORY_QUERY_KEYS = [
  'endDate',
  'excludePlaceOfInterest',
  'keywords',
  'location',
  'page',
  'radiusKm',
  'startDate',
  'tags',
];

export const API_KEYS = [
  'endDate',
  'excludePlaceOfInterest',
  'keywords',
  'latitude',
  'longitude',
  'page',
  'pageSize',
  'parentItemId',
  'radiusKm',
  'startDate',
  'tags',
];

export const ERROR_CODES = {
  1: 'API Critical Error',
};
